import { Flex } from "@instructure/ui";
import { t } from "i18next";
import ProgressStepper from "../../ProgressStepper";
import { getCourseReviewSteps } from "../utils";
import CourseReviewActions from "./CourseReviewActions";
import FacultyActions from "./FacultyActions";

const CourseActions = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "1.5rem",
        height: "100%",
      }}
    >
      <ProgressStepper steps={getCourseReviewSteps(t)} currentStep={3} />
      <div
        style={{
          flex: 1,
          margin: "-0.75rem",
          padding: "0.75rem",
          overflowY: "hidden",
        }}
      >
        <Flex gap="medium" height="100%">
          <Flex.Item shouldGrow shouldShrink height="100%">
            <FacultyActions />
          </Flex.Item>
          <Flex.Item height="100%">
            <div style={{ height: "100%", borderRight: "1px solid #ccc" }} />
          </Flex.Item>
          <Flex.Item size="50%" height="100%">
            <CourseReviewActions />
          </Flex.Item>
        </Flex>
      </div>
    </div>
  );
};

export default CourseActions;
